<template>
  <div style="width: 100%;height: 100%;overflow: hidden">
  <div class="nothing-data" v-if="todayData.length === 0"></div>
  <div v-else style="height: calc(100% - 20px);width: 90%;margin: 10px auto" id="bar" ref="wrap"></div>
</div>
</template>

<script>
export default {
  name: 'indexTodayService',
  data () {
    return {
      todayData: [],
      ServiceTypeTodayLevelTwoCount: [
        // {servicetype: '咨询服务', servicecount: 45},
        // {servicetype: '主动关爱', servicecount: 34},
        // {servicetype: '辅助就医', servicecount: 52},
        // {servicetype: '心率报警', servicecount: 34}
      ],
      isShow: false
    }
  },
  created () {
    // 今日服务数据
  },
  mounted () {
    this.isShow = true
    if (this.todayData.length > 0) {
      this.getChartData()
    }
  },
  methods: {
    getRefresh (arr) {
      // console.log('今日服务数据', arr)
      this.todayData = []
      this.ServiceTypeTodayLevelTwoCount = arr
      this.getStartData()
    },
    getStartData () {
      // console.log('用户区域11', this.ServiceTypeTodayLevelTwoCount)
      // let arr = ['咨询服务', '代办代叫', '辅助就医', '紧急救助服务', '主动关爱', '快递跑腿']
      for (let i = 0; i < this.ServiceTypeTodayLevelTwoCount.length; i++) {
        // if (arr.indexOf(this.ServiceTypeTodayLevelTwoCount[i].servicetype) > -1) {
        //   let obj = {
        //     name: this.ServiceTypeTodayLevelTwoCount[i].servicetype,
        //     value: this.ServiceTypeTodayLevelTwoCount[i].servicecount
        //   }
        //   this.todayData.push(obj)
        // }
        let obj = {
          name: this.ServiceTypeTodayLevelTwoCount[i].servicetype,
          value: this.ServiceTypeTodayLevelTwoCount[i].servicecount
        }
        this.todayData.push(obj)
      }
      let vm = this
      if (this.isShow) {
        setTimeout(() => {
          if (this.todayData.length > 0) {
            vm.getChartData()
          }
        }, 100)
      }
    },
    getChartData () {
      // let colors = []
      // for (let i = 0; i < this.todayData.length; i++) {
      //   if (this.todayData[i].name === '紧急救助服务') {
      //     colors.push('#33ffff')
      //   } else if (this.todayData[i].name === '咨询服务') {
      //     colors.push('#ffcc33')
      //   } else if (this.todayData[i].name === '代办代叫') {
      //     colors.push('#3399ff')
      //   } else if (this.todayData[i].name === '辅助就医') {
      //     colors.push('#33ff77')
      //   } else if (this.todayData[i].name === '主动关爱') {
      //     colors.push('#ff8833')
      //   } else if (this.todayData[i].name === '快递跑腿') {
      //     colors.push('#ddff33')
      //   }
      // }
      let chart = this.$echarts.init(this.$refs.wrap)
      chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        grid: {
          top: '2%',
          left: '20%',
          right: '10%',
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            name: '今日服务',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 35,
              borderColor: '#6a62ff',
              borderWidth: 0
            },
            label: {
              show: true,
              position: 'outside'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '20',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: this.todayData
            // color: colors
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexTodayService.vue